<ion-modal [isOpen]="isOpen" (didDismiss)="fechar()">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Próximas Escalas</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="fechar()">Fechar</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <!-- Seletor de data -->
      <ion-item>
        <ion-label position="stacked">Selecione a data</ion-label>
        <ion-datetime 
          [(ngModel)]="dataSelecionada" 
          (ionChange)="onDataSelecionadaChange()" 
          presentation="date"
          [max]="dataMaxima" 
          display-format="DD/MM/YYYY">
        </ion-datetime>
      </ion-item>

      <ion-progress-bar *ngIf="isLoading" type="indeterminate" color="primary"></ion-progress-bar>

      <!-- Conteúdo da escala -->
      <div *ngIf="!isLoading && folhaSelecionada" style="margin-top: 20px;">
        
        <!-- Cabeçalho - Linha 1: Veículo, Data, Papeleta -->
        <ion-grid>
          <ion-row>
            <ion-col size="4">
              <ion-item>
                <ion-input label="Veículo:" [value]="folhaSelecionada.veiculo?.numeroVeiculo" readonly></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="4">
              <ion-item>
                <ion-input label="Data:" [value]="folhaSelecionada.dataServico | date:'dd/MM/yyyy'" readonly></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="4">
              <ion-item>
                <ion-input label="Pap.:" [value]="folhaSelecionada.papeleta" readonly></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>

          <!-- Linha 2: Hr Início, Hr Final, Serviço -->
          <ion-row>
            <ion-col size="4">
              <ion-item>
                <ion-input label="Hr. Início:" [value]="formatarHora(folhaSelecionada.horarioInicial)" readonly></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="4">
              <ion-item>
                <ion-input label="Hr. Final:" [value]="formatarHora(folhaSelecionada.horarioFinal)" readonly></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="4">
              <ion-item>
                <ion-input label="Serv.:" [value]="folhaSelecionada.numeroServico" readonly></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>

          <!-- Linha 3: Grupo Alocação, Grupo Linha, Tarefa Dupla -->
          <ion-row>
            <ion-col size="4">
              <ion-item>
                <ion-input label="GP Linha:" [value]="codigoGrupoLinha" readonly></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="4">
              <ion-item>
                <ion-input label="Tarefa:" [value]="tarefaDupla" readonly></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>

          <!-- Linha 4: Colaborador (ocupando toda largura) -->
          <ion-row>
            <ion-col size="12">
              <ion-item>
                <ion-input label="Colaborador:" [value]="motorista?.nome" readonly></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>

        <!-- Tabela de Viagens -->
        <div style="margin-top: 20px;">
          <div class="table-responsive">
            <table class="custom-table">
              <thead>
                <tr>
                  <th>Linha</th>
                  <th>Evento</th>
                  <th>Início</th>
                  <th>Fim</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tarefa of listaDeTarefas">
                  <td [ngClass]="{'pendente': !tarefa.horaInicio, 'finalizada': tarefa.horaInicio}">
                    {{ formatarLinhaPrefixo(tarefa.linhaPrefixo) }}
                  </td>
                  <td class="evento-cell">{{ tarefa.evento }}</td>
                  <td class="horario-cell">{{ formatarHora(tarefa.horarioInicio) }}</td>
                  <td class="horario-cell">{{ formatarHora(tarefa.horarioFim) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Mensagem quando não há escala -->
      <div *ngIf="!isLoading && !folhaSelecionada" style="text-align: center; margin-top: 50px;">
        <ion-icon name="calendar-outline" style="font-size: 64px; color: #ccc;"></ion-icon>
        <p style="margin-top: 20px; color: #666;">Nenhuma escala encontrada para esta data.</p>
        <p style="color: #999; font-size: 14px;">Selecione outra data para visualizar.</p>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>